import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function EditProfile() {
    const [telephone, setTelephone] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("membreToken");

        if (!token) {
            navigate("/membre/login", { replace: true });
            return;
        }

        const loadUser = async () => {
            try {
                const res = await fetch("/api/membre?action=getInfo", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ token }),
                });

                const data = await res.json();

                if (data.success) {
                    setTelephone(data.user.telephone || "");
                    setEmail(data.user.email || "");
                }
            } catch (err) {
                console.error(err);
            }
        };

        loadUser();
    }, [navigate]);


    async function handleSubmit(e) {
        e.preventDefault();

        const token = localStorage.getItem("membreToken");
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email.trim())) {
        toast.error("Veuillez entrer une adresse email valide.");
        return;
    }

        const res = await fetch("/api/updateProfile", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token   
            },
            body: JSON.stringify({
                telephone,
                email,
            }),
        });

        const data = await res.json();

        if (data.success) {
            localStorage.setItem("membreToken", data.token);
            toast.success("Informations mises à jour ✔️");
            navigate("/membre/profile");
        } else {
            toast.error(data.message || "Erreur");
        }
    }




    return (
        <div className="max-w-4xl mx-auto px-4 py-8">

            
            <div className="mb-10">
                <h1 className="text-3xl font-extrabold text-slate-800 tracking-tight">
                    Modifier mes informations
                </h1>
                <p className="text-gray-500 mt-2">
                    Gardez vos informations à jour pour rester connecté avec l’association.
                </p>
            </div>

            
            <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-10 transition-all duration-300 hover:shadow-2xl">

                <form onSubmit={handleSubmit} className="space-y-8" method="POST">

                    
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-gray-600">
                            Adresse Email
                        </label>

                        <div className="relative">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="
                w-full pl-4 pr-4 py-3 rounded-xl border border-gray-200
                focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                outline-none transition-all duration-200
                bg-gray-50 focus:bg-white
              "
                                placeholder="exemple@email.com"
                            />
                        </div>
                    </div>

                    
                    <div className="space-y-2">
                        <label className="text-sm font-semibold text-gray-600">
                            Numéro de téléphone
                        </label>

                        <div className="relative">
                            <input
                                type="text"
                                value={telephone}
                                onChange={(e) => setTelephone(e.target.value)}
                                className="
                w-full pl-4 pr-4 py-3 rounded-xl border border-gray-200
                focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                outline-none transition-all duration-200
                bg-gray-50 focus:bg-white
              "
                                placeholder="06XXXXXXXX"
                            />
                        </div>
                    </div>

                    
                    <div className="border-t border-gray-100 pt-6 flex flex-col sm:flex-row gap-4">

                        <button
                            type="button"
                            onClick={() => navigate("/membre/profile")}
                            className="
              flex-1 py-3 rounded-xl border border-gray-300
              hover:bg-gray-100 transition font-medium
            "
                        >
                            Annuler
                        </button>

                        <button
                            type="submit"
                            className="
              flex-1 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600
              hover:from-blue-700 hover:to-indigo-700
              text-white font-semibold shadow-lg
              transition-all duration-300 hover:scale-[1.02]
            "
                        >
                            Sauvegarder les modifications
                        </button>

                    </div>

                </form>
            </div>

        </div>
    );


}
